<template>
  <div
    :class="[
      'flex h-8 items-center gap-1 rounded-md border bg-white px-2.5 text-sm transition-colors',
      search ? 'border-indigo-200 bg-indigo-50' : 'border-gray-200 text-gray-600',
    ]"
  >
    <vue-feather type="search" size="14" class="shrink-0 text-gray-400" />
    <Input v-model="search" type="text" placeholder="Search..." class="search-input" @input="searchLoading = true" />
    <button v-if="search" class="shrink-0 rounded p-0.5 hover:bg-gray-200" @click="clearSearch">
      <vue-feather type="x" size="12" class="text-gray-400" />
    </button>
    <div v-if="searchLoading" class="shrink-0">
      <div class="h-3 w-3 animate-spin rounded-full border-2 border-gray-300 border-t-gray-600" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import { debounce } from 'lodash';
import { Input } from '@/components/ui/input';

const searchLoading = ref<boolean>(false);
const search = ref<string>('');

const emit = defineEmits(['search-changed']);

function searchQuery() {
  emit('search-changed', { search: { field: 'name_or_email', value: search.value } });
  searchLoading.value = false;
}

function clearSearch() {
  search.value = '';
  searchQuery();
}

watch(
  search,
  debounce(() => {
    searchQuery();
  }, 1000)
);
</script>

<style scoped>
@reference "tailwindcss";
.search-input {
  @apply border-none shadow-none outline-none p-0 h-auto min-h-0 w-24 text-gray-700 placeholder:text-gray-400;
}

.spinner {
  height: 22px;
  width: 22px;
  animation: rotateSpinner 0.8s infinite linear;
  border: 2px solid black;
  border-right-color: transparent;
  border-radius: 50%;
  z-index: 50;
}

@keyframes rotateSpinner {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
